import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53730698"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Dati anagrafici", -1))
const _hoisted_2 = { class: "ion-color-danger" }
const _hoisted_3 = { class: "ion-color-danger" }
const _hoisted_4 = { class: "ion-color-danger" }
const _hoisted_5 = { class: "ion-color-danger" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label-text sc-ion-input-md",
  style: {"font-size":"12px"}
}, "Data di nascita*", -1))
const _hoisted_7 = { class: "ion-color-danger" }
const _hoisted_8 = { class: "ion-color-danger" }
const _hoisted_9 = { class: "ion-color-danger" }
const _hoisted_10 = { class: "ion-color-danger" }
const _hoisted_11 = { class: "ion-color-danger" }
const _hoisted_12 = { class: "ion-color-danger" }
const _hoisted_13 = { class: "ion-color-danger" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recapito personale", -1))
const _hoisted_15 = { class: "ion-color-danger" }
const _hoisted_16 = { class: "ion-color-danger" }
const _hoisted_17 = { class: "ion-color-danger" }
const _hoisted_18 = { class: "ion-color-danger" }
const _hoisted_19 = { class: "ion-color-danger" }
const _hoisted_20 = { class: "ion-color-danger" }
const _hoisted_21 = { class: "ion-color-danger" }
const _hoisted_22 = { class: "ion-color-danger" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Dati azienda", -1))
const _hoisted_24 = { class: "ion-color-danger" }
const _hoisted_25 = { class: "ion-color-danger" }
const _hoisted_26 = { class: "ion-color-danger" }
const _hoisted_27 = { class: "ion-color-danger" }
const _hoisted_28 = { class: "ion-color-danger" }
const _hoisted_29 = { class: "ion-color-danger" }
const _hoisted_30 = { class: "ion-color-danger" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.aicanet.it/documents/10776/100372/REGOLAMENTO+SOCI_2015.pdf/1c466f01-f04e-44cb-829e-ee09f831edd3",
  target: "_blank"
}, "Regolamento Soci", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.aicanet.it/documents/10776/91049/Codice+Etico_2015.pdf/0150f706-b873-4599-919b-df464529c790",
  target: "_blank"
}, "Codice Etico", -1))
const _hoisted_34 = { class: "" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Agevolazioni riservate a Soci Ordinari appartenenti alle seguenti categorie:", -1))
const _hoisted_36 = { class: "ion-color-danger" }
const _hoisted_37 = { class: "ion-color-danger" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Per i membri delle associazioni sotto indicate verrà applicato uno sconto del 20% sulla quota intera", -1))
const _hoisted_40 = { class: "" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("u", null, "versata"),
  /*#__PURE__*/_createTextVNode(" la quota di iscrizione che deve essere corrisposta "),
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("u", null, "dal singolo richiedente")
  ]),
  /*#__PURE__*/_createTextVNode(" contestualmente ( con carta di credito ) o successivamente rispetto all'invio della domanda stessa ( con bonifico bancario ).")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "deve coincidere", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Selezionare modalità di pagamento della quota associativa*:", -1))
const _hoisted_44 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Intestatario bonifico: AICA – Associazione Italiana per l’Informatica ed il Calcolo Automatico"),
  /*#__PURE__*/_createTextVNode(" sul c/c intestato ad AICA – Associazione Italiana per l’Informatica ed il Calcolo Automatico – P.le Rodolfo Morandi 2 – 20121 Milano c/o Gruppo bancario Crédit Agricole Italia Piazza San Fedele, 4 - 20121 MILANO - IBAN: IT21J0623001633000015087944 ")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Completa la domanda", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "indicare facoltativamente la Sezione Territoriale presso cui si intende svolgere attività associativa", -1))
const _hoisted_48 = { class: "ion-color-danger" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "indicare a quale indirizzo si desidera venga recapitata la corrispondenza Aica*")
], -1))
const _hoisted_50 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "I dati forniti verranno trattati da AICA secondo quanto indicato nell' INFORMATIVA AI SENSI DELL'ARTICOLO 13 del regolamento UE 2016/679"),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://domino.aicanet.it/beta/indiraic.nsf/privacy-soci"
    }, " visualizza informativa")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Acquisizione del consenso al trattamento dei dati personali ai sensi del REGOLAMENTO UE 2016/679")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Il/la sottoscritto/a, acquisite le informazioni fornite dal Titolare del trattamento ai sensi dell’art. 13 del Regolamento UE 2016/679, in merito al trattamento dei propri dati personali per le finalità indicate ai seguenti punti dell’informativa:")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "punto 3a, 3b")
], -1))
const _hoisted_53 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "punto 3c")
], -1))
const _hoisted_55 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "punto 3d")
], -1))
const _hoisted_57 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "punto 3e")
], -1))
const _hoisted_59 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "punto 3f")
], -1))
const _hoisted_61 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "punto 3g")
], -1))
const _hoisted_63 = {
  key: 0,
  class: "ion-color-danger ion-padding"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "NB:"),
    /*#__PURE__*/_createTextVNode("Di seguito indichiamo la procedura da seguire per l’associazione ad AICA di un soggetto che abbia meno di 16 anni.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("1. Scaricare "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://domino.aicanet.it/beta/indiraic.nsf/Soci-AICA-Consenso-Minori.pdf",
      target: "_blank"
    }, "il modulo"),
    /*#__PURE__*/_createTextVNode(" per l’acquisizisone del consenso per minori di 16 anni")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "2. Compilare il modulo scaricato"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("3. Scansionare il modulo ed inviare la scansione all’indirizzo "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:privacy@aicanet.it" }, "privacy@aicanet.it")
  ])
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Pagamento", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Carta di credito tramite circuito Paypal", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Bonifico bancario", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Per completare la registrazione è necessario effettuare il bonifico bancario della quota sopra indicata al beneficiario:", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, "AICA - Associazione Italiana per l’Informatica ed il Calcolo Automatico", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, "P.le Rodolfo Morandi 2 – 20121 Milano", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, " c/o Gruppo bancario Crédit Agricole Italia Piazza San Fedele, 4 - 20121 MILANO", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, "IBAN: IT21J0623001633000015087944", -1))
const _hoisted_73 = {
  key: 6,
  id: "paypal-button-container"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "< Indietro", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Avanti >", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_field = _resolveComponent("field")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_VForm = _resolveComponent("VForm")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/login" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Iscrizione ")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_progress_bar, { value: $data.progress }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($data.step === 1)
            ? (_openBlock(), _createBlock(_component_VForm, {
                key: 0,
                ref: "formStep1",
                validateOnMount: false
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item_divider, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "tipo socio",
                            label: "tipo socio",
                            rules: "required",
                            modelValue: $data.user.tiposocio,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.user.tiposocio) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_select, _mergeProps({
                                name: "tipo socio",
                                label: "Indica la tipologia di socio",
                                onChange: $options.onTiposocioChange
                              }, field, { labelPlacement: "floating" }), {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tipiSoci, (sez) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      value: sez.code,
                                      key: sez.code
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(sez.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1040, ["onChange"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(errors['tipo socio']), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "cognome",
                            label: "Cognome",
                            rules: "required",
                            modelValue: $data.user.cognome,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.user.cognome) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Cognome*" }, field, { labelPlacement: "floating" }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(errors.cognome), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "nome",
                            label: "Nome",
                            rules: "required",
                            modelValue: $data.user.nome,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.user.nome) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                label: "Nome*",
                                name: "nome"
                              }, field, { labelPlacement: "floating" }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_4, _toDisplayString(errors.nome), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "codiceFiscale",
                            label: "Codice fiscale",
                            rules: "required",
                            modelValue: $data.user.cfisc,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.user.cfisc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Codice fiscale*" }, field, { labelPlacement: "floating" }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(errors.codiceFiscale), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "datanasc",
                            label: "Data di nascita",
                            rules: "required",
                            modelValue: $data.user.datanasc,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.user.datanasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createElementVNode("div", null, [
                                _hoisted_6,
                                _createVNode(_component_ion_datetime_button, { datetime: "birth-date-picker" })
                              ]),
                              _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_datetime, _mergeProps({
                                    id: "birth-date-picker",
                                    presentation: "date",
                                    "prefer-wheel": true
                                  }, field), null, 16)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(errors.datanasc), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "naznasc",
                            label: "Nazione Codice fiscale",
                            rules: "required",
                            modelValue: $data.user.naznasc,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.user.naznasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Nazione di nascita*" }, field, {
                                labelPlacement: "floating",
                                type: "text"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(errors.naznasc), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "pvnasc",
                            label: "Provincia di nascita",
                            rules: "required",
                            modelValue: $data.user.pvnasc,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.user.pvnasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Provincia di nascita*" }, field, {
                                labelPlacement: "floating",
                                type: "text"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(errors.pvnasc), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "comnasc",
                            label: "Comune di nascita",
                            rules: "required",
                            modelValue: $data.user.comnasc,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.user.comnasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Comune di nascita*" }, field, {
                                labelPlacement: "floating",
                                type: "text"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(errors.comnasc), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "reccext",
                            label: "Comune di nascita estero",
                            alias: "Comune di nascita estero",
                            modelValue: $data.user.reccext,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.user.reccext) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Comune di nascita estero" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(errors.reccext), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "password",
                            label: "Password",
                            rules: "required",
                            modelValue: $data.user.passwd,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.user.passwd) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                label: "Password",
                                ref: "password",
                                name: "password",
                                type: "password",
                                labelPlacement: "floating"
                              }, field), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(errors.password), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "password_confirmation",
                            label: "conferma password",
                            rules: "required|confirmed:@password"
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                label: "Conferma password",
                                name: "password_confirmation",
                                labelPlacement: "floating",
                                type: "password"
                              }, field), null, 16)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(errors.password_confirmation), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($data.step===2)
            ? (_openBlock(), _createBlock(_component_VForm, {
                key: 1,
                ref: "formStep2"
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item_divider, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "recnaz",
                            label: "Nazione",
                            rules: "required",
                            modelValue: $data.user.recnaz,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.user.recnaz) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Nazione*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(errors.recnaz), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "recpv",
                            label: "Provincia",
                            rules: "required",
                            modelValue: $data.user.recpv,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.user.recpv) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Provincia*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(errors.recpv), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "reccom",
                            label: "Comune",
                            rules: "required",
                            modelValue: $data.user.reccom,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.user.reccom) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Comune*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(errors.reccom), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "reccap",
                            label: "CAP/ZIPCode",
                            rules: "required",
                            modelValue: $data.user.reccap,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.user.reccap) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "CAP/ZIPCode*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(errors.reccap), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "recindir",
                            label: "Indirizzo",
                            rules: "required",
                            modelValue: $data.user.recindir,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($data.user.recindir) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Indirizzo*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(errors.recindir), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "recemail",
                            label: "Email",
                            rules: "required",
                            modelValue: $data.user.recemail,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($data.user.recemail) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Email*" }, field, {
                                type: "email",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(errors.recemail), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "recph",
                            label: "Telefono",
                            rules: !$data.user.reccell ? 'required' : '',
                            modelValue: $data.user.recph,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($data.user.recph) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Telefono*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["rules", "modelValue"]),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(errors.recph), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "reccell",
                            label: "Cellulare",
                            rules: !$data.user.recph ? 'required' : '',
                            modelValue: $data.user.reccell,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($data.user.reccell) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Cellulare*" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["rules", "modelValue"]),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(errors.reccell), 1)
                        ]),
                        _: 2
                      }, 1024),
                      (!$data.user.recph && !$data.user.reccell )
                        ? (_openBlock(), _createBlock(_component_ion_label, {
                            key: 0,
                            class: "ion-padding ion-color-danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("è obbligatorio il telefono o il cellulare")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($data.step===3)
            ? (_openBlock(), _createBlock(_component_VForm, {
                key: 2,
                ref: "formStep3"
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item_divider, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azragsoc",
                            rules: "",
                            modelValue: $data.user.azragsoc,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($data.user.azragsoc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Ragione sociale" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(errors.azragsoc), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azcfisc",
                            rules: "",
                            modelValue: $data.user.azcfisc,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($data.user.azcfisc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Codice Fiscale" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(errors.azcfisc), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azpiva",
                            rules: "",
                            modelValue: $data.user.azpiva,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($data.user.azpiva) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Partita IVA" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(errors.azpiva), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azindir",
                            rules: "",
                            modelValue: $data.user.azindir,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($data.user.azindir) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Indirizzo" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(errors.azindir), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azcap",
                            rules: "",
                            modelValue: $data.user.azcap,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($data.user.azcap) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "CAP/ZIPCode" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(errors.azcap), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azpv",
                            rules: "",
                            modelValue: $data.user.azpv,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($data.user.azpv) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Provincia" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(errors.azpv), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "azcom",
                            rules: "",
                            modelValue: $data.user.azcom,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($data.user.azcom) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({ label: "Comune" }, field, {
                                type: "text",
                                labelPlacement: "floating"
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(errors.azcom), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($data.step===4)
            ? (_openBlock(), _createBlock(_component_VForm, {
                key: 3,
                ref: "formStep4"
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_text, { class: "" }, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", null, "Chiede di essere ammesso/a come SOCIO " + _toDisplayString($data.user.tiposocio.toUpperCase()) + ".", 1),
                                _hoisted_31,
                                _createTextVNode(" Con la compilazione della presente richiesta, dichiaro di aver letto ed accettato il "),
                                _hoisted_32,
                                _createTextVNode(" e il "),
                                _hoisted_33,
                                _createTextVNode(" riportati sul sito dell'Associazione. ")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      ($data.user.tiposocio.toLowerCase() == 'ordinario')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_34, [
                                    _createVNode(_component_ion_text, null, {
                                      default: _withCtx(() => [
                                        _hoisted_35
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  name: "docAta",
                                  modelValue: $data.user.docente_ata,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($data.user.docente_ata) = $event)),
                                  "label-placement": "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("docente e personale ATA di scuole pubbliche e private - quota associativa € 20,00")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  modelValue: $data.user.supervisoreecdl,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($data.user.supervisoreecdl) = $event)),
                                  name: "ECDL",
                                  "label-placement": "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("supervisore ECDL - quota associativa € 20,00")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  name: "aniDig",
                                  modelValue: $data.user.digital_animator,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($data.user.digital_animator) = $event)),
                                  "label-placement": "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("animatore digitale - quota associativa € 20,00")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            ($data.user.docente_ata || $data.user.digital_animator)
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_field, {
                                      name: "istituto",
                                      label: "Denominazione istituto",
                                      rules: "required",
                                      modelValue: $data.user.istituto,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($data.user.istituto) = $event))
                                    }, {
                                      default: _withCtx(({field}) => [
                                        _createVNode(_component_ion_input, _mergeProps({
                                          name: "istituto",
                                          label: "Denominazione istituto*"
                                        }, field, { labelPlacement: "floating" }), null, 16)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createElementVNode("span", _hoisted_36, _toDisplayString(errors.istituto), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            ($data.user.docente_ata || $data.user.digital_animator)
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_field, {
                                      name: "comuneistituto",
                                      label: "Comune istituto",
                                      rules: "required",
                                      modelValue: $data.user.comuneistituto,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($data.user.comuneistituto) = $event))
                                    }, {
                                      default: _withCtx(({field}) => [
                                        _createVNode(_component_ion_input, _mergeProps({
                                          name: "comuneistituto",
                                          label: "Comune istituto*"
                                        }, field, { labelPlacement: "floating" }), null, 16)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(errors.comuneistituto), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_38, [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _hoisted_39
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            name: "clubFIDA",
                            modelValue: $data.user.clubFIDA,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($data.user.clubFIDA) = $event)),
                            "label-placement": "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Club FIDA Inform")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            name: "IEEE",
                            modelValue: $data.user.IEEE,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($data.user.IEEE) = $event)),
                            "label-placement": "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("IEEE Computer Society")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            name: "ACM",
                            modelValue: $data.user.ACM,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($data.user.ACM) = $event)),
                            "label-placement": "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("ACM")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            name: "aium",
                            modelValue: $data.user.aium,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($data.user.aium) = $event)),
                            "label-placement": "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("AIUM Associazione Italiana Utenti Moodle Aps")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, "Quota annuale da corrispondere: " + _toDisplayString($options.calculatedQuote) + "€", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_40, [
                              _createVNode(_component_ion_text, { class: "small-font" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" La domanda si ritiene perfezionata ( v. punto 4 del Regolamento soci AICA – Ottobre 2017 ) dal momento in cui viene "),
                                  _hoisted_41,
                                  _createTextVNode(" Ove la quota di iscrizione non pervenisse contestualmente all'invio della domanda ( bonifico bancario) , in tale versamento si deve indicare e, quindi, confermare nelle note, il nominativo specifico a cui si riferisce e che "),
                                  _hoisted_42,
                                  _createTextVNode(" con quello indicato nella domanda di associazione. ")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _hoisted_43
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "payment_mode",
                                type: "radio",
                                value: "paypal",
                                rules: "required",
                                modelValue: $data.user.payment_mode,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($data.user.payment_mode) = $event))
                              }, {
                                default: _withCtx(({field, handleChange}) => [
                                  _createVNode(_component_ion_radio, _mergeProps({
                                    justify: "start",
                                    class: "ionic-padding",
                                    name: "payment_mode",
                                    value: "paypal"
                                  }, field, {
                                    onClick: (e) => handleChange(true),
                                    "label-placement": "end"
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        class: "ion-text-wrap",
                                        style: {"padding":"10px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Carta di credito tramite circuito PayPal (con iscrizione subordinata alla verifica dei requisiti)")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            class: "ionic-padding"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "payment_mode",
                                type: "radio",
                                value: "bank_transfer",
                                rules: "required",
                                modelValue: $data.user.payment_mode,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($data.user.payment_mode) = $event))
                              }, {
                                default: _withCtx(({field, handleChange}) => [
                                  _createVNode(_component_ion_radio, _mergeProps({ justify: "start" }, field, {
                                    name: "payment_mode",
                                    value: "bank_transfer",
                                    "label-placement": "end",
                                    onClick: (e) => handleChange(true)
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        class: "ion-text-wrap",
                                        style: {"padding":"10px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Bonifico bancario (con iscrizione subordinata alla verifica dei requisiti e del pagamento)")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (errors.payment_mode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Indicare la modalità di pagamento"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      ($data.user.payment_method === 'bank_transfer')
                        ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($data.step===5)
            ? (_openBlock(), _createBlock(_component_VForm, {
                key: 4,
                ref: "formStep5"
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item_divider, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_46
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _hoisted_47,
                            _createVNode(_component_field, {
                              name: "sigla",
                              rules: "required",
                              modelValue: $data.user.sigla,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($data.user.sigla) = $event))
                            }, {
                              default: _withCtx(({field}) => [
                                _createVNode(_component_ion_select, _mergeProps({
                                  name: "sigla",
                                  label: "Sezione territoriale"
                                }, field, { labelPlacement: "floating" }), {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sezioni, (sez) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        value: sez.code,
                                        key: 'sez_'+sez.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(sez.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(errors.sigla), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _hoisted_49
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "send_to",
                                type: "radio",
                                rules: "required",
                                value: "abitazione",
                                modelValue: $data.user.send_to,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($data.user.send_to) = $event))
                              }, {
                                default: _withCtx(({field, handleChange}) => [
                                  _createVNode(_component_ion_radio, _mergeProps({
                                    justify: "start",
                                    class: "ionic-padding",
                                    value: "abitazione"
                                  }, field, {
                                    name: "send_to",
                                    "label-placement": "end",
                                    onClick: (e) => handleChange(true)
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        class: "ion-text-wrap",
                                        style: {"padding":"10px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("presso abitazione")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            class: "ionic-padding"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "send_to",
                                type: "radio",
                                value: "azienda",
                                label: "indirizzo recapito corrispondenza",
                                rules: "required",
                                modelValue: $data.user.send_to,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($data.user.send_to) = $event))
                              }, {
                                default: _withCtx(({field, handleChange}) => [
                                  _createVNode(_component_ion_radio, _mergeProps({
                                    justify: "start",
                                    value: "azienda",
                                    name: "send_to"
                                  }, field, {
                                    "label-placement": "end",
                                    onClick: (e) => handleChange(true)
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        class: "ion-text-wrap",
                                        style: {"padding":"10px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("presso azienda/ente")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (errors.send_to)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Indicare dove recapitare la corrispondenza"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _hoisted_51
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _hoisted_52
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1ab",
                                        type: "radio",
                                        rules: "required",
                                        value: "Consento",
                                        modelValue: $data.user.privacy1ab,
                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($data.user.privacy1ab) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("presta il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    class: "ionic-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1ab",
                                        type: "radio",
                                        rules: "",
                                        value: ""
                                      }, {
                                        default: _withCtx(({field}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end"
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("nega il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (errors.privacy1ab)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Il consenso è obbligatorio"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _hoisted_54
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1c",
                                        type: "radio",
                                        rules: "required",
                                        value: "Consento",
                                        modelValue: $data.user.privacy1c,
                                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($data.user.privacy1c) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("presta il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    class: "ionic-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1c",
                                        type: "radio",
                                        rules: "required",
                                        value: ""
                                      }, {
                                        default: _withCtx(({field}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end"
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("nega il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (errors.privacy1c)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Il consenso è obbligatorio"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _hoisted_56
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1d",
                                        type: "radio",
                                        rules: "required",
                                        value: "Consento",
                                        modelValue: $data.user.privacy1d,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($data.user.privacy1d) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("presta il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    class: "ionic-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1d",
                                        type: "radio",
                                        rules: "required",
                                        value: "Non consento",
                                        modelValue: $data.user.privacy1d,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($data.user.privacy1d) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("nega il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (errors.privacy1d)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, "La scelta è obbligatoria"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _hoisted_58
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1e",
                                        type: "radio",
                                        rules: "required",
                                        value: "Consento",
                                        modelValue: $data.user.privacy1e,
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($data.user.privacy1e) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("presta il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    class: "ionic-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1e",
                                        type: "radio",
                                        rules: "required",
                                        value: "Non consento",
                                        modelValue: $data.user.privacy1e,
                                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($data.user.privacy1e) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("nega il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (errors.privacy1e)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_59, "La scelta è obbligatoria"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _hoisted_60
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1f",
                                        type: "radio",
                                        rules: "required",
                                        value: "Consento",
                                        modelValue: $data.user.privacy1f,
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($data.user.privacy1f) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("presta il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    class: "ionic-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1f",
                                        type: "radio",
                                        rules: "required",
                                        value: "Non consento",
                                        modelValue: $data.user.privacy1f,
                                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($data.user.privacy1f) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("nega il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (errors.privacy1f)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, "La scelta è obbligatoria"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_radio_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _hoisted_62
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1g",
                                        type: "radio",
                                        rules: "required",
                                        value: "Consento",
                                        modelValue: $data.user.privacy1g,
                                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (($data.user.privacy1g) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("presta il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    class: "ionic-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_field, {
                                        name: "privacy1g",
                                        type: "radio",
                                        rules: "",
                                        value: "Non consento",
                                        modelValue: $data.user.privacy1g,
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($data.user.privacy1g) = $event))
                                      }, {
                                        default: _withCtx(({field, handleChange}) => [
                                          _createVNode(_component_ion_radio, _mergeProps({
                                            justify: "start",
                                            class: "ionic-padding"
                                          }, field, {
                                            name: "send_to",
                                            "label-placement": "end",
                                            onClick: (e) => handleChange(true)
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("nega il consenso")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1040, ["onClick"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (errors.privacy1g)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, "La scelta è obbligatoria"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _hoisted_64
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($data.step===6)
            ? (_openBlock(), _createBlock(_component_VForm, {
                key: 5,
                ref: "formStep6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _hoisted_65
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Anno di riferimento")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createElementVNode("strong", null, _toDisplayString($options.getYearRef), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Quota")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createElementVNode("strong", null, _toDisplayString($options.calculatedQuote) + "€", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Modalità scelta")
                            ]),
                            _: 1
                          }),
                          ($data.user.payment_mode === 'paypal')
                            ? (_openBlock(), _createBlock(_component_ion_label, {
                                key: 0,
                                slot: "end"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_66
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ($data.user.payment_mode === 'bank_transfer')
                            ? (_openBlock(), _createBlock(_component_ion_label, {
                                key: 1,
                                slot: "end"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_67
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      ($data.user.payment_mode === 'bank_transfer')
                        ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _hoisted_68,
                                  _hoisted_69,
                                  _hoisted_70,
                                  _hoisted_71,
                                  _hoisted_72
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  ($data.paymentFeedback.status === 'COMPLETED')
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        color: "success"
                      }, {
                        default: _withCtx(() => [
                          ($data.user.payment_mode === 'paypal')
                            ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Pagamento completato")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_ion_label, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Registrazione completata")
                                ]),
                                _: 1
                              })),
                          _createVNode(_component_ion_icon, {
                            icon: $setup.checkmarkCircleOutline,
                            slot: "end"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : ($data.paymentFeedback.status && $data.paymentFeedback.status !== 'COMPLETED' && $data.paymentFeedback.status !== 'PENDING')
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 1,
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Pagamento rifiutato")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              icon: $setup.closeCircleOutline,
                              slot: "end"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                  ($data.paymentFeedback.status === 'COMPLETED')
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 2,
                        shape: "round",
                        expand: "block",
                        size: "medium",
                        onClick: $options.goToDashboard,
                        style: {"margin":"15px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Clicca qui per proseguire ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($data.paymentFeedback.status !== 'COMPLETED')
            ? (_openBlock(), _createElementBlock("div", _hoisted_73))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { translucent: "true" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          ($data.step>1)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                shape: "round",
                                disabled: $data.paymentFeedback.status || $data.paypalButtonsCreated,
                                expand: "block",
                                size: "medium",
                                onClick: $options.goBack,
                                fill: "clear"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_74
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            shape: "round",
                            expand: "block",
                            disabled: $data.paymentFeedback.status || $data.paypalButtonsCreated,
                            size: "medium",
                            onClick: $options.goNext,
                            fill: "clear"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_75
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}